import { Loader } from "../Loader";
import { useUpgradeFlowFormContext } from "../UpgradeFlowContext";

export const LoadingRoute = () => {
  const { loadingMessage } = useUpgradeFlowFormContext();

  return (
    <Loader title={loadingMessage.title} subtitle={loadingMessage.subtitle} />
  );
};
